<template>
  <div class="hello">

    <div class='header'>
      <img src="@/assets/logo.png" class="logo">
<!--      <div>{{appName}}</div>-->
    </div>
    <div class='content'>
      <div>申请获取以下权限</div>
      <div class="text">获得你的公开信息(昵称，头像等)</div>
    </div>

  </div>
</template>

<script>

  import {getOpenid} from '@/api/wx-login'

  var wx = require('../../node_modules/jweixin-module/lib/index.js');

  export default {
    name: 'HelloWorld',
    data() {
      return {
        appName: 'e电管家',
        code: null,
        msg: 'Welcome to Your Vue.js App'
      }
    },
    created() {
    },
    mounted() {

      let code = this.getParameterByName('code')
      let orgId = this.getParameterByName('orgid')
      let appid = this.getParameterByName('appid')
      let appName = this.getParameterByName('appName')
      this.appName = appName == null || appName == '' ? 'e电管家' : appName
      this.getOpenid(code, appid)
    },
    methods: {
      getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        //匹配所有符合条件的，并取最后一个
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'g');
        var results = url.match(regex);
        var tempResults = results != null && results[results.length - 1] != undefined ? results[results.length - 1] : '';
        var finalResults = regex.exec(tempResults);
        if (!finalResults) return '';
        if (!finalResults[2]) return '';
        return decodeURIComponent(finalResults[2].replace(/\+/g, ' '));
      },

      //获取公众号的openid
      getOpenid(code, appid) {
        let params = {code: code, appid: appid}
        getOpenid(params).then(response => {
          //拿到openid跳转到小程序页面
          wx.miniProgram.getEnv(function (res) {
            wx.miniProgram.reLaunch({
              url: '/pages/login/authorize?mpAppid=' + response.appid + '&mpOpenid=' + response.openid //跳转的链接
            })
          })
        }).catch((error) => {
          alert(error)
        })

      },
      getrandom() {
        var code = ''
        //设置长度，这里看需求，我这里设置了4
        var codeLength = 10
        //设置随机字符
        var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'y', 'f', 'g', 'h', 'i', 'g', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z')

        //循环codeLength 我设置的4就是循环4次
        for (var i = 0; i < codeLength; i++) {
          //设置随机数范围,这设置为0 ~ 36
          var index = Math.floor(Math.random() * 36)
          //字符串拼接 将每次随机的字符 进行拼接
          code += random[index]
        }
        //将拼接好的字符串赋值给展示的code
        return code
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header {
    margin: 45px 10px;
    border-bottom: 1px solid #ccc;
    text-align: center;
    height: 160px;
  }

  .header .logo {
    width: 100px;
  }

  .content {
    margin: 10px auto 90px auto;
    text-align: center;
  }

  .content .text {
    display: block;
    color: #ccc;
    margin-top: 10px;
  }

  .bottom {
    border-radius: 80px;
    margin: 70px 50px;
    font-size: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue